import {useTitle} from 'hooks';
import {Link, useParams} from 'react-router-dom';
import {Button, Divider, Transitioner} from 'components';

import HomePlanUsage from './components/Home.Plan.Usage';
import HomeOnboarding from './components/Home.Onboarding';

interface IPageHomeProps {}

const PageHome = ({}: IPageHomeProps) => {
  useTitle('Home');

  const params = useParams();
  const workspace = params.workspace ?? '';
  const resource = params.resource ?? '';

  return (
    <Transitioner key={`/${workspace}/${resource}`}>
      <div className="flex items-center justify-between gap-3">
        <div className="sm:flex-auto">
          <h1 className="font-medium text-lg dark:text-white">Onboarding</h1>
          <p className="mt-2 text-sm text-gray-700 dark:text-darkText">Follow these steps on a desktop to setup your AR experience.</p>
        </div>
        <Link to={`/${workspace}/help`}>
          <Button text="Help" size="small" />
        </Link>
      </div>
      <Divider />
      <Transitioner delay={0.1}>
        <HomePlanUsage />
      </Transitioner>
      <Divider />
      <Transitioner delay={0.2}>
        <HomeOnboarding />
      </Transitioner>
    </Transitioner>
  );
};

export default PageHome;
